export const COMPANYDATA_GET_PARTS = "COMPANYDATA_GET_PARTS";
export const COMPANYDATA_NEW_PART = "COMPANYDATA_NEW_PART";
export const COMPANYDATA_Update_PART = "COMPANYDATA_UPDATE_PART";
export const COMPANYDATA_DELETE_PART = "COMPANYDATA_DELETE_PART";
export const COMPANYDATA_RESET_STATES = "COMPANYDATA_RESET_STATES";
